<template>
    <Dialog
        :visible="visible"
        modal
        header="Solicitar Cancelamento"
        :style="{ width: '480px' }"
        aria-labelledby="marcar-cancelamento-titulo"
        @update:visible="$emit('update:visible', $event)"
    >
        <form @submit.prevent="onSubmit">
            <div class="field mt-3">
                <FloatLabel>
                    <Select
                        v-model="form.prioridade"
                        :options="prioridadeOpt"
                        optionLabel="label"
                        optionValue="value"
                        class="w-full"
                        :invalid="!!errors.prioridade"
                    />
                    <label>Prioridade *</label>
                </FloatLabel>
                <small v-if="errors.prioridade" class="p-error">{{ errors.prioridade }}</small>
            </div>

            <div class="field mt-4">
                <FloatLabel>
                    <Textarea
                        v-model="form.motivo"
                        class="w-full"
                        rows="4"
                        :invalid="!!errors.motivo"
                    />
                    <label>Motivo *</label>
                </FloatLabel>
                <small v-if="errors.motivo" class="p-error">{{ errors.motivo }}</small>
            </div>

            <div class="flex justify-content-between mt-4">
                <div class="flex gap-2">
                    <Button
                        v-if="cancelamentoExistente && cancelamentoExistente.id"
                        type="button"
                        label="Ver cancelamento"
                        icon="pi pi-eye"
                        severity="info"
                        size="small"
                        outlined
                        @click="$emit('show-cancelamento', cancelamentoExistente)"
                    />
                </div>
                <div class="flex gap-2">
                    <Button
                        type="button"
                        label="Cancelar"
                        severity="secondary"
                        size="small"
                        @click="$emit('update:visible', false)"
                    />
                    <Button
                        type="submit"
                        label="Salvar"
                        icon="pi pi-check"
                        severity="success"
                        size="small"
                        :loading="isLoading"
                    />
                </div>
            </div>
        </form>
    </Dialog>
</template>

<script>
import Dialog from 'primevue/dialog';
import Button from 'primevue/button';
import FloatLabel from 'primevue/floatlabel';
import Select from 'primevue/select';
import Textarea from 'primevue/textarea';

import Cancelamento from '@/service/cancelamento.js';

export default {
    name: 'MarcarCancelamentoDialog',
    components: { Dialog, Button, FloatLabel, Select, Textarea },
    props: {
        visible: { type: Boolean, required: true },
        contratoId: { type: [Number, String], default: null },
    },
    emits: ['update:visible', 'saved', 'show-cancelamento'],
    data() {
        return {
            isLoading: false,
            form: { prioridade: null, motivo: '' },
            errors: {},
            cancelamentoExistente: null,
            prioridadeOpt: [
                { label: 'Baixa', value: 'baixa' },
                { label: 'Média', value: 'media' },
                { label: 'Alta', value: 'alta' },
            ],
        };
    },
    watch: {
        visible(novo) {
            if (novo) {
                this.carregarCancelamentoDoContrato();
            } else {
                this.cancelamentoExistente = null;
            }
        },
        contratoId() {
            if (this.visible) {
                this.carregarCancelamentoDoContrato();
            }
        },
    },
    methods: {
        carregarCancelamentoDoContrato() {
            this.cancelamentoExistente = null;
            if (!this.contratoId) return;
            const contratoConsultado = this.contratoId;
            Cancelamento.porContrato(contratoConsultado)
                .then((response) => {
                    if (contratoConsultado !== this.contratoId) return;
                    const data = response.data?.data;
                    this.cancelamentoExistente = (data && data.id) ? data : null;
                })
                .catch(() => {
                    this.cancelamentoExistente = null;
                });
        },
        validate() {
            this.errors = {};
            if (!this.form.prioridade) this.errors.prioridade = 'Prioridade obrigatória.';
            if (!this.form.motivo?.trim()) this.errors.motivo = 'Motivo obrigatório.';
            return Object.keys(this.errors).length === 0;
        },
        onSubmit() {
            if (!this.validate()) return;
            this.isLoading = true;

            const payload = {
                contrato_id: this.contratoId,
                prioridade: this.form.prioridade,
                motivo: this.form.motivo,
            };

            Cancelamento.create(payload)
                .then(() => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Cancelamento solicitado.', life: 5000 });
                    this.$emit('saved');
                    this.$emit('update:visible', false);
                    this.form = { prioridade: null, motivo: '' };
                })
                .catch((error) => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: Cancelamento.extractErrorMessage(error), life: 5000 });
                })
                .finally(() => { this.isLoading = false; });
        },
    },
};
</script>
